module.exports = __webpack_public_path__ + "static/media/bharat-pe-logo.6cfd67a6.svg";